import permission from "./permission";
import debounce from "./debounce"
import closeSelect from './closeSelect'
import drag from "./drag"

const directives = {
    permission,
    debounce,
    closeSelect,
    drag
}

export default {
    install(Vue) {
        Object.keys(directives).forEach((key) => {
            Vue.directive(key, directives[key])
        })
    },
}



// WEBPACK FOOTER //
// ./src/digitalHuman/directives/index.js